(() => {
	const gridSelector = '#product-grid';
	const paginationSelector = '.js-pagination';
	const containerSelector = '#ProductGridContainer';

	let loading = false;
	let nextUrl = null;
	let scrollBound = false;
	let containerObserver = null;

	const getEls = () => {
		return {
			container: document.querySelector(containerSelector),
			grid: document.querySelector(gridSelector),
			pagination: document.querySelector(paginationSelector)
		};
	};

	const hidePagination = () => {
		const { pagination } = getEls();
		if (pagination) pagination.style.display = 'none';
	};

	const readNextUrl = () => {
		const { pagination } = getEls();
		return pagination?.dataset?.nextUrl || null;
	};

	const loadNext = async () => {
		if (loading) return;

		// 都度読み直す（絞り込み後のDOM差し替えに強くする）
		if (!nextUrl) nextUrl = readNextUrl();
		if (!nextUrl) return;

		loading = true;

		try {
			const res = await fetch(nextUrl, { credentials: 'same-origin' });
			const html = await res.text();
			const doc = new DOMParser().parseFromString(html, 'text/html');

			const newGrid = doc.querySelector(gridSelector);
			const newPagination = doc.querySelector(paginationSelector);

			const { grid } = getEls();
			if (newGrid && grid) {
				newGrid.querySelectorAll('li').forEach((li) => grid.appendChild(li));
			}

			nextUrl = newPagination?.dataset?.nextUrl || null;

			if (!nextUrl) {
				window.removeEventListener('scroll', onScroll);
				scrollBound = false;
			}
		} catch (e) {
			console.error(e);
		} finally {
			loading = false;
		}
	};

	const onScroll = () => {
		const scrollBottom = window.innerHeight + window.scrollY;
		const pageHeight = document.documentElement.scrollHeight;

		if (pageHeight - scrollBottom < 800) loadNext();
	};

	const initInfiniteScroll = () => {
		const { grid, pagination } = getEls();
		if (!grid || !pagination) return;

		// 「ページネーションが出てしまう」対策：nextが無くても常に隠す
		hidePagination();

		nextUrl = readNextUrl();

		if (nextUrl && !scrollBound) {
			window.addEventListener('scroll', onScroll);
			scrollBound = true;
		}
	};

	// #ProductGridContainer が差し替わっても追従できるように「再接続」
	const attachContainerObserver = () => {
		const { container } = getEls();
		if (!container) return;

		// すでに別のcontainerを監視してたら張り直し
		if (containerObserver) containerObserver.disconnect();

		let rafId = 0;
		containerObserver = new MutationObserver(() => {
			cancelAnimationFrame(rafId);
			rafId = requestAnimationFrame(() => {
				initInfiniteScroll();
			});
		});

		containerObserver.observe(container, { childList: true, subtree: true });
	};

	// document全体を軽く監視して「container差し替え」を検知→observer再接続
	const attachBodyObserver = () => {
		let rafId = 0;
		const bodyObserver = new MutationObserver(() => {
			cancelAnimationFrame(rafId);
			rafId = requestAnimationFrame(() => {
				attachContainerObserver();
				initInfiniteScroll();
			});
		});
		bodyObserver.observe(document.body, { childList: true, subtree: true });
	};

	const boot = () => {
		initInfiniteScroll();
		attachContainerObserver();
		attachBodyObserver();
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot, { once: true });
	} else {
		boot();
	}
})();
